export const SVG_ICONS = [
  {
    iconName: 'ink_highlighter',
    filename: 'ink_highlighter.svg',
  },
  {
    iconName: 'docs_add_on',
    filename: 'docs_add_on.svg',
  },
  {
    iconName: 'edit',
    filename: 'edit.svg',
  },
  {
    iconName: 'format_ink_highlighter',
    filename: 'format_ink_highlighter.svg',
  },
  {
    iconName: 'account_balance',
    filename: 'account_balance_fill_0.svg',
  },
  {
    iconName: 'article',
    filename: 'article_fill_0.svg',
  },
  {
    iconName: 'forms_add_on',
    filename: 'forms_add_on_fill_0.svg',
  },
  {
    iconName: 'join',
    filename: 'join.svg',
  },
  {
    iconName: 'visibility',
    filename: 'visibility.svg',
  },
  {
    iconName: 'euro',
    filename: 'euro.svg',
  },
  {
    iconName: 'grouped_bar_chart',
    filename: 'grouped_bar_chart.svg',
  },
  {
    iconName: 'lock',
    filename: 'lock.svg',
  },
  {
    iconName: 'lock_open',
    filename: 'lock_open.svg',
  },
  { iconName: 'order_approve', filename: 'order_approve.svg' },
  { iconName: 'price_check', filename: 'price_check.svg' },
  { iconName: 'patient_list', filename: 'patient_list.svg' },
  { iconName: 'draft', filename: 'draft.svg' },
  { iconName: 'image', filename: 'image.svg' },
  { iconName: 'picture_as_pdf', filename: 'picture_as_pdf.svg' },
  { iconName: 'info', filename: 'info.svg' },
  { iconName: 'note_stack', filename: 'note_stack.svg' },
  { iconName: 'help', filename: 'help.svg' },
  { iconName: 'redo', filename: 'redo.svg' },
  { iconName: 'location_on', filename: 'location_on.svg' },
  { iconName: 'folder_check_2', filename: 'folder_check_2.svg' },
];
